'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var gray1 = exports.gray1 = '#F2F2F2';
var gray2 = exports.gray2 = '#E5E5E5';
var gray3 = exports.gray3 = '#CCC';
var gray4 = exports.gray4 = '#B2B2B2';
var gray5 = exports.gray5 = '#999';
var gray6 = exports.gray6 = '#7F7F7F';
var gray7 = exports.gray7 = '#666';
var gray8 = exports.gray8 = '#4D4D4D';
var grayNormal = exports.grayNormal = '#555';
var grayMedium = exports.grayMedium = '#888';
var grayMediumish = exports.grayMediumish = '#AEAEAE';
var grayLightish = exports.grayLightish = '#BDBDBD';
var grayLight = exports.grayLight = '#E2E2E2';
var grayLighter = exports.grayLighter = '#EEE';
var grayCool = exports.grayCool = '#F6F7F8';
var grayWhiteSmoke = exports.grayWhiteSmoke = '#F5F5F5';
var gray = {
  1: gray1,
  2: gray2,
  3: gray3,
  4: gray4,
  5: gray5,
  6: gray6,
  7: gray7,
  8: gray8,
  grayNormal: grayNormal,
  grayMedium: grayMedium,
  grayMediumish: grayMediumish,
  grayLightish: grayLightish,
  grayLight: grayLight,
  grayLighter: grayLighter,
  grayCool: grayCool,
  grayWhiteSmoke: grayWhiteSmoke
};
exports.default = gray;